<template>
	<div v-if="items?.length > 0">
		<div @click="isOpen = !isOpen" class="section-header-container pa-1 display-flex flex-row flex-align-center">
			<div class="section-title">{{ title }}</div>
			<v-icon class="chevron ml-1">mdi-chevron-{{ isOpen ? 'up' : 'down' }}</v-icon>
		</div>
		<v-expand-transition>
			<div v-if="isOpen" class="display-flex flex-column">
				<div class="display-flex flex-row flex-align-center">
					<div class="section-title px-1">The apps below don't support add-ons</div>
					<v-menu rounded="lg" :close-on-content-click="false" open-on-hover right top nudge-top="10" nudge-right="10">
						<template v-slot:activator="{ on, attrs }">
							<div v-on="on" v-bind="attrs" class="display-flex flex-row flex-align-center">
								<SIcon name="installation-tab-info" width="12" height="17" />
							</div>
						</template>
						<div class="content-container display-flex flex-column py-2 px-4">
							<h3 class="reg bold">Apps with no contexts</h3>
							<h4 class="reg">
								In order to let you build add-ons for apps, contexts are required. The apps in this list don't currently have contexts, so
								add-ons are not available for them. You can still use actions in these apps in your features.
							</h4>
						</div>
					</v-menu>
				</div>
				<PlacementMenuItemRouterLink
					class="mb-1"
					v-on="$listeners"
					:key="item.id || i"
					v-for="(item, i) in items"
					v-bind="getItemProps(item)"
				/>
			</div>
		</v-expand-transition>
	</div>
</template>

<script>
import PlacementMenuItemRouterLink from '@/components/ProjectMenu/PlacementMenuItemRouterLink.vue';
import CreateAndManageService from '@/views/AppLayout/ManageAndCreate/create-and-manage-service.js';
export default {
	name: 'PlacementLessAddOnsMenu',
	props: { items: { type: Array } },
	components: { PlacementMenuItemRouterLink },
	computed: {
		title() {
			return `${this.isOpen ? 'Hide' : 'Show'} other apps`;
		},
	},
	methods: {
		getItemProps(item) {
			return CreateAndManageService.getItemProps(item);
		},
	},
	data() {
		return { isOpen: false };
	},
};
</script>
<style scoped lang="scss">
.section-title {
	font-size: 11px;
	color: #8f95ab;
	letter-spacing: 0px;
}
.section-header-container {
	cursor: pointer;
	&:hover {
		background: #f4f5f66c;
	}
}
.chevron {
	font-size: 18px;
	margin-top: -2px;
}
.content-container {
	max-width: 340px;
	background: var(--white);
}
</style>
